// Экран 6 «История платежей» из ТЗ раздел 3.3 — единственный оставшийся раздел на этой странице.
//
// Экран 8 «Промокоды» перенесён на CheckoutScreen.tsx (2026-08-20, под кнопку "Оплатить") —
// логически он ближе к покупке, чем к истории платежей. Компонент —
// src/components/PromoCodeSection.tsx, сама логика не менялась, только место.
//
// Экран 7 «Отмена подписки» (только автопродление) — БЫЛ здесь отдельным разделом до 2026-08-20,
// переехал на MySubscriptionScreen.tsx: полноценное управление КАЖДЫМ экземпляром подписки
// отдельно (запрос пользователя) означает, что переключатель автопродления должен быть у СВОЕЙ
// карточки конкретной подписки, а не один глобальный на отдельном экране, который неявно бил по
// "текущей" подписке пользователя.
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ApiError, fetchPayments, type Payment } from "../api/client";

const PAYMENT_STATUS_KEYS: Record<Payment["status"], string> = {
  pending: "payment_status_pending",
  succeeded: "payment_status_succeeded",
  failed: "payment_status_failed",
  refunded: "payment_status_refunded",
};

const PAYMENT_TYPE_KEYS: Record<Payment["type"], string> = {
  purchase: "payment_type_purchase",
  renewal: "payment_type_renewal",
  upgrade: "payment_type_upgrade",
  refund: "payment_type_refund",
};

function PaymentsSection() {
  const { t, i18n } = useTranslation();
  const [payments, setPayments] = useState<Payment[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const dateLocale = i18n.language === "en" ? "en-US" : "ru-RU";

  useEffect(() => {
    let cancelled = false;
    fetchPayments()
      .then((data) => {
        if (!cancelled) setPayments(data);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err instanceof ApiError ? err.message : String(err));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section>
      <h2>{t("payments_title")}</h2>
      {error && <p role="alert">{t("payments_error")}</p>}
      {!error && payments === null && <p>{t("loading")}</p>}
      {payments !== null && payments.length === 0 && <p>{t("payments_empty")}</p>}
      {payments !== null && payments.length > 0 && (
        <ul>
          {payments.map((payment) => (
            <li key={payment.id}>
              {new Date(payment.created_at).toLocaleDateString(dateLocale)} —{" "}
              {t(PAYMENT_TYPE_KEYS[payment.type])}: {payment.amount} {payment.currency} —{" "}
              {t(PAYMENT_STATUS_KEYS[payment.status])}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

// Ссылки на юридические документы (2026-08-20, запрос пользователя) — ПОКА заглушки: реальных
// текстов/URL документов ещё нет, `href="#"` + preventDefault, чтобы клик ничего не делал вместо
// прокрутки страницы наверх. Заменить на настоящие ссылки, когда документы появятся — больше
// никаких изменений не потребуется, кроме самого href.
//
// `<section>`, не `<div>` — сознательно: глобальное правило `section + section` (theme.css) уже
// даёт ровно то, что попросил пользователь ("отступ, потом горизонтальная черта") без новой CSS.
function LegalLinksSection() {
  const { t } = useTranslation();
  return (
    <section>
      <p>
        <a href="#" onClick={(event) => event.preventDefault()}>
          {t("legal_license_agreement")}
        </a>
      </p>
      <p>
        <a href="#" onClick={(event) => event.preventDefault()}>
          {t("legal_privacy_policy")}
        </a>
      </p>
    </section>
  );
}

export function MoreScreen() {
  const { t } = useTranslation();
  return (
    <div>
      <h1>{t("more_title")}</h1>
      <PaymentsSection />
      <LegalLinksSection />
    </div>
  );
}
